import React from "react";
function Footer(){
    return(
        <footer>
        <hr></hr>    
        <h5 class="footer-header">Contact</h5>
        <ul>
                <li><a href="https://github.com/Prachi-Gore"><img src="https://img.icons8.com/fluency/48/null/github.png" alt="github"/></a></li>
                <li><a href="https://www.linkedin.com/in/prachi-gore-4772a11a5"><img src="https://img.icons8.com/color/48/000000/linkedin.png"alt="linkedin"/></a></li>
                
            </ul>
    </footer>

    )
}
export default Footer;